/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { getTenantDetail } from "../../../store/tenant/api";
import { getJWTDecoded } from "../../../../utils/userUtils";

import {
  ALLOWED_PRODUCTS_NAMES_MAPPING,
  ALLOWED_PRODUCTS_TO_PURCHASE,
  PRODUCTS_CONFIG,
} from "../constants";
import {
  AllowedProductNames,
  PRO_TIER,
  BASIC_TIER,
  ProductStatus,
  ProductTier,
} from "../components/types";
import {
  Tenant,
  TenantUserData,
} from "../../../shared/interfaces/model/tenant.interface";
import { useGlobalContext } from "../../../context/GlobalContext";

export const useProductStatus = () => {
  const [productStatuses, setProductStatuses] = useState<
    Record<string, ProductStatus>
  >({
    [PRODUCTS_CONFIG.NEXBOT.appCode]: {
      isPurchased: false,
      isEnabled: false,
      isUpdateAvailable: false,
      isExipred: false,
      paidDetails: {
        name: PRODUCTS_CONFIG.NEXBOT.name,
        appUrl: PRODUCTS_CONFIG.NEXBOT.baseUrl,
        desc: PRODUCTS_CONFIG.NEXBOT.description,
        invoices: [],
        payment: "",
        paymentStatus: "",
        expireDate: "",
      },
    },
    [PRODUCTS_CONFIG.NEXCODE.appCode]: {
      isPurchased: false,
      isEnabled: false,
      isUpdateAvailable: false,
      isExipred: false,
      paidDetails: {
        name: PRODUCTS_CONFIG.NEXCODE.name,
        appUrl: PRODUCTS_CONFIG.NEXCODE.baseUrl,
        desc: PRODUCTS_CONFIG.NEXCODE.description,
        invoices: [],
        payment: "",
        paymentStatus: "",
        expireDate: "",
      },
    },
  });

  const [isLoading, setIsLoading] = useState(true);
  const [isTenantUser, setIsTenantUser] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { updateTenantData} = useGlobalContext();

  const getProductPrice = (
    productName: AllowedProductNames,
    tier: ProductTier
  ) => {
    const key = ALLOWED_PRODUCTS_NAMES_MAPPING.get(
      productName
    ) as keyof typeof PRODUCTS_CONFIG;
    const price = PRODUCTS_CONFIG[key]?.pricing?.[tier] || 0;
    return price;
  };

  const calculateIfProductIsPurchased = (expireDate: string) => {
    const expDate = new Date(expireDate);
    return !Number.isNaN(expDate.getTime()) && expDate > new Date();
  };

  const calculateIfUpdateIsAvailable = (
    expireDate: string,
    tier: ProductTier
  ) => {
    const expDate = new Date(expireDate);
    const isPurchased =
      !Number.isNaN(expDate.getTime()) && expDate > new Date();
    return isPurchased && (tier === BASIC_TIER || tier === PRO_TIER);
  };


  const calculateIfProductIsExpire = (prod: any) => {
    const expDate = new Date(prod.expireDate?.split(" ")[0]);
    return Boolean(expDate < new Date() && prod.tier);
  }

  useEffect(() => {
    const fetchProductStatuses = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const userEmail = localStorage.getItem("userEmail");
        window.localStorage.setItem("isTenantUser", "false");
        const role = localStorage.getItem("role");
        const tenantId = localStorage.getItem("tenantId");
        if (!token) throw new Error("No token found");

        const decodedToken = getJWTDecoded(token);
        const ten = await getTenantDetail(decodedToken.firebase?.tenant || tenantId || "");
        const {isMarketplaceUserPaid, marketplaceUserProjects, marketplaceUserExpireDate, marketplaceTierType} = updateTenantData(ten);

        console.log("ten ========>", ten);

        if (ten.testProducts?.length > 0) {
          const prepareProductStatuses = {
            ...productStatuses,
          };
          ten.testProducts.forEach((product: any) => {
            prepareProductStatuses[product.productAppCode].paidDetails = {
              ...prepareProductStatuses[product.productAppCode].paidDetails,
              ...product,
            };
          });
          setProductStatuses(prepareProductStatuses);
          setProductStatuses((prev) => ({
            ...prev,
            ...ten.testProducts.forEach((product: any) => {
              return {
                [product.productAppCode]: {
                  ...prev[product.productAppCode],
                  paidDetails: {
                    ...prev[product.productAppCode]?.paidDetails,
                    ...product,
                  },
                },
              };
            }),
          }));
        }

        if (userEmail && ten.tenantUserData) {
          ten.tenantUserData.forEach((tenantUserData: TenantUserData) => {
            if (userEmail === tenantUserData.userEmail) {
              setIsTenantUser(true);
              window.localStorage.setItem("isTenantUser", "true");
              if (tenantUserData.testProducts?.length > 0) {
                const val = { ...productStatuses };
                const data = tenantUserData.testProducts.forEach(
                  (product: any) => {
                    const findProduct = Object.values(PRODUCTS_CONFIG).find(
                      (p) => p.name === product
                    );

                    val[findProduct?.appCode!] = {
                      ...val[findProduct?.appCode!],
                      isEnabled: ALLOWED_PRODUCTS_TO_PURCHASE.includes(product),
                      isUpdateAvailable: calculateIfUpdateIsAvailable(
                        product.expireDate.split(" ")[0],
                        product.tier as ProductTier
                      ),
                      isExipred: calculateIfProductIsExpire(product),
                      paidDetails: {
                        ...val[findProduct?.appCode!]?.paidDetails,
                        ...product,
                      },
                    };
                  }
                );
                setProductStatuses((prev) => {
                  const newProductStatuses = {
                    ...prev,
                    ...val,
                  };  
                  return newProductStatuses;
                });
              }
            }
          });
        }

        const parsedToken = JSON.parse(atob(token.split(".")[1])); // Decodifica il payload del token JWT
        const { availableProducts } = parsedToken;

        if (availableProducts) {
          const availableProductAppCode = Object.values(PRODUCTS_CONFIG).map(
            (product) => product.appCode
          );
          availableProducts.forEach((product: any) => {
            if (availableProductAppCode.includes(product.productAppCode)) {
              const productConfigDetails = Object.values(PRODUCTS_CONFIG).find(
                (p) => p.appCode === product.productAppCode
              );

              const findProduct = ten?.testProducts?.find(
                (p: any) => p.productAppCode === product.productAppCode
              );

              setProductStatuses((prev) => ({
                ...prev,
                [product.productAppCode]: {
                  ...{
                    isPurchased: calculateIfProductIsPurchased(
                      findProduct?.expireDate.split(" ")[0]
                    ),
                    isExipred: calculateIfProductIsExpire(findProduct),
                    isUpdateAvailable: calculateIfUpdateIsAvailable(
                      findProduct?.expireDate.split(" ")[0],
                      findProduct?.tier as ProductTier
                    ),
                    paidDetails: {
                      ...prev[product.productAppCode]?.paidDetails,
                      ...product,
                      price: getProductPrice(
                        productConfigDetails?.name as AllowedProductNames,
                        findProduct?.tier as ProductTier
                      ),
                      name: productConfigDetails?.name,
                      appUrl: productConfigDetails?.baseUrl,
                      desc: productConfigDetails?.description,
                    },
                  },
                  isEnabled: Boolean(prev[product.productAppCode]?.isEnabled),
                },
              }));
            }
          });
        }


        if (productStatuses && Object.keys(productStatuses).length > 0 && isMarketplaceUserPaid && marketplaceUserProjects?.length > 0) {
          const prepareProductStatuses = {
                ...productStatuses,
            };
            marketplaceUserProjects.forEach((product: any) => {
              console.log("marketplaceUserProjects productStatuses ========>", prepareProductStatuses[product])
                if (!prepareProductStatuses[product]) {
                    return;
                }

                prepareProductStatuses[product] = {
                  ...prepareProductStatuses[product],
                    isEnabled: isMarketplaceUserPaid,
                    isPurchased: true,
                    isExipred: calculateIfProductIsExpire({expireDate: marketplaceUserExpireDate, tier: marketplaceTierType}),
                    isUpdateAvailable: calculateIfUpdateIsAvailable(marketplaceUserExpireDate, marketplaceTierType),
                };
            });
            console.log("marketplaceUserProjects productStatuses ========>", prepareProductStatuses)
            setProductStatuses(prepareProductStatuses);
        }
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Unknown error occurred")
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductStatuses();
  }, []);

  return { productStatuses, isLoading, error };
};
